import React from 'react'
import { Navigate as Redirect } from 'react-router'
import qs from 'qs'
import { get, isEmpty, omit } from 'lodash'

import exportActions from '../../actions/BenefitsSetsExports'
import indexActions from '../../actions/LevelFundedBenefitsSets'
import approvalStateDisplay from '../BenefitsSet/approvalStateDisplay'
import BulkPublishLink from '../BenefitsSet/BulkPublishLink'
import { BenefitsSetIndex } from '../BenefitsSet/BenefitsSetIndex'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import connectIndex from '../../lib/connectIndex'
import withRouter from '../../lib/withRouter'
import exportCsvActions from '../../actions/BenefitsSetCsvExports'

export class LevelFundedBenefitsSetIndex extends Component {
  static propTypes = {
    ...omit(BenefitsSetIndex.propTypes, 'productLine')
  }

  get bulkPublishButton() {
    const planCount = get(this.props.pagination, 'total', 0)

    if (planCount === 0 || isEmpty(this.queryParams)) {
      return null
    }

    return (
      <BulkPublishLink
        key="bulk-publish-link"
        planCount={planCount}
        queryParams={this.queryParams}
        productLine="level_funded"
      />
    )
  }

  get queryParams() {
    return qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
  }

  render() {
    const { benefitsSetCsvExport } = this.props
    if (benefitsSetCsvExport && benefitsSetCsvExport.created) {
      return (
        <Redirect
          push
          to={{ pathname: '/benefits_set_csv_exports' }}
        />
      )
    }

    return (
      <div>
        <BenefitsSetIndex
          {...this.props}
          name="Level Funded Benefits Set"
          columnsList={columnsList}
          includeBulkEditLink
          includeDiffSetLink
          includeSelectAll
          includeNewRecordLink
          includeCsvExportLink
          searchPlaceholder="Search by Name, Vericred ID, Document, Issuer Name or Issuer ID"
          searchColumns={['name', 'vericred_id', 'issuer_id', 'issuer_name', 'document_id']}
          actionLinks={[this.bulkPublishButton]}
          extraQueryParams={{ audience: ['Level Funded'] }}
          productLine="level_funded"
        />
      </div>
    )
  }
}

export const columnsList = [
  { key: 'name', label: 'Name', display: BenefitsSetIndex.showLinkDisplay('/level_funded_benefits') },
  { key: 'issuer_name', label: 'Issuer' },
  { key: 'carrier_id', label: 'Issuer ID' },
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },

  { key: 'effective_date', label: 'Effective Date', filterable: true },
  { key: 'expiration_date', label: 'Expiration Date', filterable: true },
  { key: 'updated_at', label: 'Last Updated At', display: IndexComponent.dateTimeDisplay },
  { key: 'last_updated_by_username', label: 'Last Updated By' },
  {
    key: 'approval_state',
    label: 'Status',
    display: approvalStateDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'networks',
    label: 'Networks',
    sortable: false,
    display: BenefitsSetIndex.networksDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  }
]

export const filters = [
  {
    key: 'effective_date',
    dateField: true
  },
  {
    key: 'expiration_date',
    dateField: true
  },
  {
    key: 'approval_state',
    options: [
      { value: 'new', text: 'New' },
      { value: 'approved', text: 'Approved' },
      { value: 'rejected', text: 'Rejected' },
      { value: 'corrected', text: 'Corrected' },
      { value: 'amended', text: 'Amended' }
    ]
  },
  {
    key: 'publish_state',
    options: [
      { value: 'needs_publishing', text: 'Needs Publishing' },
      { value: 'failed_to_publish', text: 'Failed to publish' },
      { value: 'published', text: 'Published' },
      { value: 'unpublished', text: 'Unpublished' },
      { value: 'publishing', text: 'Publishing' }
    ]
  }
]

export default connectIndex(
  withRouter(LevelFundedBenefitsSetIndex),
  'levelFundedBenefitsSets',
  indexActions,
  filters,
  {
    benefitsSetPath: '/level_funded_benefits',
    includeCsvExportLink: true
  },
  [
    { action: exportActions.create.main, key: 'createBenefitsSetExport' },
    { action: exportActions.create.reset, key: 'resetCreateBenefitsSetExport' },
    { action: exportCsvActions.create.main, key: 'createBenefitsSetCsvExport' },
    { action: exportCsvActions.create.reset, key: 'resetCreateBenefitsSetCsvExport' }
  ],
  [
    { key: 'benefitsSetExport', reducer: 'benefitsSetsExports', action: 'create' },
    { key: 'benefitsSetCsvExport', reducer: 'benefitsSetCsvExports', action: 'create' }
  ]
)
